import styles from "components/cards/myInfoCard.module.scss";
import utilStyles from "styles/utils.module.scss";
import ArrowRightLargeIcon from "images/icons/arrow_right_black_16.svg";
import {useContext} from "react";
import UserContext from "context/AuthContext";
import {numberWithComma} from "common/utils";
import Link from "next/link";
import {
    COUNTRY_CODE,
    couponsRoute,
    getCreatorRoute,
    getInfluencerRoute,
    KAKAO_CLIENT_ID,
    myInfoRoute,
    pointsRoute,
    reviewRoute,
    SITE_URL
} from "common/const";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import classNames from "classnames";
import Image from "next/image";
import DefaultProfileIcon from "images/icons/default_profile.svg";
import CopyBlackIcon from "images/icons/copy_black_2.svg";
import FullButton from "components/buttons/FullButton";
import {toast} from "react-toastify";
import {useRouter} from "next/router";
import {REGEX_NICKNAME_LEGAL} from "pages/auth/sign-up";
import * as yup from "yup";
import TextInput from "components/input/TextInput";

import InstagramIcon from "images/icons/instagram_icon.svg";
import YoutubeIcon from "images/icons/youtube_icon.svg";
import TiktokIcon from "images/icons/tiktok_icon.svg";
import NaverBlogIcon from "images/icons/naver_blog_icon.svg";
import LinkTreeIcon from "images/icons/link_tree_icon.svg";
import Script from "next/script";
import SpeechBubble from "components/SpeechBubble";

import useTranslation from 'next-translate/useTranslation';
import {KOREA_COUNTRY_CODE} from "common/i18n";


const ProfileImage = ({user}) => {
    const isLarge = useMediaQuery(`(min-width:${utilStyles.breakpointDesktop})`);

    return (
        <>
            {
                user.profile_image_url
                    ?
                    <div className={classNames(styles.profileImage, styles.profileImageBorder)}>
                        <Image unoptimized src={user.profile_image_url} width={isLarge ? 80: 72} height={isLarge ? 80: 72} objectFit="fill" />
                    </div>
                    : <DefaultProfileIcon className={styles.profileImage} viewBox="0 0 32 32" />
            }
        </>
    )
}



export const KEY_INTRODUCTION = 'introduction';
export const KEY_INSTAGRAM_LINK = 'instagram_link';
export const KEY_YOUTUBE_LINK = 'youtube_link';
export const KEY_TIKTOK_LINK = 'tiktok_link';
export const KEY_NAVER_BLOG_LINK = 'naver_blog_link';
export const KEY_LINK_TREE_LINK = 'link_tree_link';

const KEY_CREATOR_CODE = 'creator_code';
const KEY_CREATOR_CODE_EXISTS = 'creator_code_exists';
const KEY_CREATOR_CODE_CONTAINS_ALPHABET = 'creator_code_contains_alphabet';
const KEY_CREATOR_CODE_LEGAL = 'creator_code_legal';
const REGEX_CREATOR_CODE_LEGAL = REGEX_NICKNAME_LEGAL;
const CREATOR_ERROR_FIELDS = [KEY_CREATOR_CODE_CONTAINS_ALPHABET, KEY_CREATOR_CODE_LEGAL, KEY_CREATOR_CODE];
export const SellerShopInfoForm = ({formik, isLoading}) => {
    const { t } = useTranslation('components-cards-MyInfoCard');
    const {errors, values, setFieldValue, touched, setFieldTouched, resetForm, handleSubmit, setTouched, setFieldError} = formik;

    return (
        <>
            <div className={styles.titleRow}>
                <span className={styles.titleRowTitle}>{t('SellerShopInfoForm.introduction.title')}</span>
                <span className={styles.titleRowSubTitle}>{t('SellerShopInfoForm.introduction.optional')}</span>
                <div style={{marginTop: 12}}>
                    <TextInput
                        readonly={isLoading}
                        value={values[KEY_INTRODUCTION]}
                        onChange={(e) => setFieldValue(KEY_INTRODUCTION, e)}
                        maxLength={150}
                        multiLine
                        height={160}
                        placeholder={t('SellerShopInfoForm.introduction.placeholder')}
                    />
                </div>
            </div>
            <div className={styles.titleRow}>
                <span className={styles.titleRowTitle}>{t('SellerShopInfoForm.links.title')}</span>
                <span className={styles.titleRowSubTitle}>{t('SellerShopInfoForm.links.optional')}</span>
            </div>
            <div>
                <div className={styles.linkRow}>
                    <InstagramIcon viewBox="0 0 40 40" className={styles.linkIcon}/>
                    <div className={styles.linkInputWrapper}>
                        <TextInput
                            readonly={isLoading}
                            value={values[KEY_INSTAGRAM_LINK]}
                            onChange={(e) => setFieldValue(KEY_INSTAGRAM_LINK, e)}
                            placeholder={t('SellerShopInfoForm.links.placeholder')}
                        />
                    </div>
                </div>
                <div className={styles.linkRow}>
                    <YoutubeIcon viewBox="0 0 40 40" className={styles.linkIcon}/>
                    <div className={styles.linkInputWrapper}>
                        <TextInput
                            readonly={isLoading}
                            value={values[KEY_YOUTUBE_LINK]}
                            onChange={(e) => setFieldValue(KEY_YOUTUBE_LINK, e)}
                            placeholder={t('SellerShopInfoForm.links.placeholder')}
                        />
                    </div>
                </div>
                <div className={styles.linkRow}>
                    <TiktokIcon viewBox="0 0 40 40" className={styles.linkIcon}/>
                    <div className={styles.linkInputWrapper}>
                        <TextInput
                            readonly={isLoading}
                            value={values[KEY_TIKTOK_LINK]}
                            onChange={(e) => setFieldValue(KEY_TIKTOK_LINK, e)}
                            placeholder={t('SellerShopInfoForm.links.placeholder')}
                        />
                    </div>
                </div>
                {
                    COUNTRY_CODE === KOREA_COUNTRY_CODE ? (
                        <div className={styles.linkRow}>
                            <NaverBlogIcon viewBox="0 0 40 40" className={styles.linkIcon}/>
                            <div className={styles.linkInputWrapper}>
                                <TextInput
                                    readonly={isLoading}
                                    value={values[KEY_NAVER_BLOG_LINK]}
                                    onChange={(e) => setFieldValue(KEY_NAVER_BLOG_LINK, e)}
                                    placeholder={t('SellerShopInfoForm.links.placeholder')}
                                />
                            </div>
                        </div>
                    ) : (
                        <div className={styles.linkRow}>
                            <LinkTreeIcon
                                viewBox="0 0 40 40" className={styles.linkIcon}
                            />
                            <div className={styles.linkInputWrapper}>
                                <TextInput
                                    readonly={isLoading}
                                    value={values[KEY_LINK_TREE_LINK]}
                                    onChange={(e) => setFieldValue(KEY_LINK_TREE_LINK, e)}
                                    placeholder={t('SellerShopInfoForm.links.placeholder')}
                                />
                            </div>
                        </div>
                    )
                }
            </div>
        </>
    )
}

SellerShopInfoForm.initialValues = {
    [KEY_INTRODUCTION]: '',
    [KEY_INSTAGRAM_LINK]: '',
    [KEY_YOUTUBE_LINK]: '',
    [KEY_TIKTOK_LINK]: '',
    [KEY_NAVER_BLOG_LINK]: '',
}

SellerShopInfoForm.validationSchema = {
    [KEY_INTRODUCTION]: yup.string().max(150),
    [KEY_INSTAGRAM_LINK]: yup.string(),
    [KEY_YOUTUBE_LINK]: yup.string(),
    [KEY_TIKTOK_LINK]: yup.string(),
    [KEY_NAVER_BLOG_LINK]: yup.string(),
    [KEY_CREATOR_CODE_LEGAL]: yup.boolean().when(KEY_CREATOR_CODE, (code, schema) => {
        if (!code) return schema;
        if (!code.match(REGEX_CREATOR_CODE_LEGAL)) {
            return schema.oneOf([true]).required();
        }
    }),
}

SellerShopInfoForm.preSubmit = (values, callback) => {
    if (values[KEY_INSTAGRAM_LINK] && !values[KEY_INSTAGRAM_LINK].trim().startsWith('https://') && !values[KEY_INSTAGRAM_LINK].trim().startsWith('http://')) {
        if (COUNTRY_CODE === KOREA_COUNTRY_CODE)  {
            alert("인스타그램 링크는 http:// 또는 https://로 시작해야 합니다.");
        } else {
            alert("instagram link should start with http:// or https://");
        }
        return false;
    }

    if (values[KEY_YOUTUBE_LINK] && !values[KEY_YOUTUBE_LINK].trim().startsWith('https://') && !values[KEY_YOUTUBE_LINK].trim().startsWith('http://')) {
        if (COUNTRY_CODE === KOREA_COUNTRY_CODE)  {
            alert("유튜브 링크는 http:// 또는 https://로 시작해야 합니다.");
        } else{
            alert("youtube link should start with http:// or https://");
        }
        return false;
    }

    if (values[KEY_TIKTOK_LINK] && !values[KEY_TIKTOK_LINK].trim().startsWith('https://') && !values[KEY_TIKTOK_LINK].trim().startsWith('http://')) {
        if (COUNTRY_CODE === KOREA_COUNTRY_CODE)  {
            alert("틱톡 링크는 http:// 또는 https://로 시작해야 합니다.");
        } else {
            alert("tiktok link should start with http:// or https://");
        }
        return false;
    }

    if (values[KEY_NAVER_BLOG_LINK] && !values[KEY_NAVER_BLOG_LINK].trim().startsWith('https://') && !values[KEY_NAVER_BLOG_LINK].trim().startsWith('http://')) {
        if (COUNTRY_CODE === KOREA_COUNTRY_CODE)  {
            alert("네이버 블로그 링크는 http:// 또는 https://로 시작해야 합니다.");
        } else {
            alert("naver blog link should start with http:// or https://");
        }
        return false;
    }

    if (values[KEY_LINK_TREE_LINK] && !values[KEY_LINK_TREE_LINK].trim().startsWith('https://') && !values[KEY_LINK_TREE_LINK].trim().startsWith('http://')) {
        if (COUNTRY_CODE === KOREA_COUNTRY_CODE)  {
            alert("링크트리 링크는 http:// 또는 https://로 시작해야 합니다.");
        } else {
            alert("link tree link should start with http:// or https://");
        }
        return false;
    }

    return true;
}

const MyInfoMobileCardV2 = () => {
    const {t} = useTranslation('components-cards-MyInfoCard')
    const {user, isApplicableGlobalReferral} = useContext(UserContext);
    const routeLink = isApplicableGlobalReferral ? `${SITE_URL}${getInfluencerRoute(user.code)}`
        : Boolean(user.code) ? `${SITE_URL}${getCreatorRoute(user.code)}` : '';
    const reviewCount = user?.writable_reviews?.count || 0;
    const maxReviewReward = user?.writable_reviews?.max_points || 0;
    const router = useRouter();

    const onReviewCountClick = () => {
        typeof mixpanel !== 'undefined' && mixpanel.track('MyInfoCardReviewCountClick');
    };

    const onPointClick = () => {
        typeof mixpanel !== 'undefined' && mixpanel.track('MyInfoCardPointClick');
    };

    const onCouponClick = () => {
        typeof mixpanel !== 'undefined' && mixpanel.track('MyInfoCardCouponClick');
    };

    const onProfileImageClick = () => {
        typeof mixpanel !== 'undefined' && mixpanel.track('MyInfoCardProfileImageClick');
        router.push(myInfoRoute);
        return;
    };

    const copyMyShopLinkToClipboard = () => {
        navigator.clipboard.writeText(routeLink).then(() => {
            toast.info(t('MyInfoMobileCard.linkCopied'));
        })
    };

    return (
        <div className={styles.mobileContainer}>
            <Script src="https://developers.kakao.com/sdk/js/kakao.js" onLoad={() => {
                if (!Boolean(Kakao?.isInitialized())) {
                    Kakao.init(KAKAO_CLIENT_ID);
                }
            }} strategy="afterInteractive"/>
            <div className={styles.profileWrapper} onClick={onProfileImageClick}>
                <div className={styles.profileImageDivWrapper} onClick={onProfileImageClick}>
                    <ProfileImage user={user}/>
                </div>
                <div className={styles.profileNameWrapper}>
                    <div>
                        <span className={styles.profileNickname}>{user.nickname}</span>
                        <ArrowRightLargeIcon className={styles.arrow} viewBox="0 0 16 16"/>
                    </div>
                    {
                        routeLink &&
                        <div className={styles.profileLinkWrapper} onClick={async (e) => {
                            copyMyShopLinkToClipboard();
                            e.stopPropagation();
                        }}>
                            <span className={styles.profileRouteLink}>{routeLink?.replaceAll('https://', '')}</span>
                            <div className={styles.copyBlackWrapper}>
                                <CopyBlackIcon />
                            </div>
                        </div>
                    }
                </div>
            </div>
            <div className={styles.sellerShopButtonWrapper}>
                {
                    routeLink && (
                        <Link href={routeLink}>
                            <a className={utilStyles.fullWidth} onClick={() => {
                                mixpanel.track('GoToMyShop');
                            }}>
                                <FullButton title={t('MyInfoMobileCard.myShopButton')} height={40} fontSize={15}/>
                            </a>
                        </Link>
                    )
                }
            </div>
            <div className={styles.mobileRewardContainer} style={{marginTop: 12}}>
                <Link href={reviewRoute}>
                    <a className={styles.rewardWrapper} onClick={onReviewCountClick}>
                        <span className={styles.rewardKey}>{t('MyInfoMobileCard.rewards.review')}</span>
                        <span className={styles.rewardValue}>{numberWithComma(reviewCount)}</span>
                        {
                            maxReviewReward > 0 &&
                            <div className={styles.reviewBubbleWrapper}>
                                <SpeechBubble
                                    sidePadding={10} verticalPadding={6}
                                    pointLength={5}
                                    top={true}
                                    bottom={false}
                                    backgroundColor={'#191919'}
                                >
                                    <div className={styles.reviewBubbleContent}>
                                        {t('MyInfoMobileCard.rewards.pointsReward', {amount: numberWithComma(maxReviewReward)})}
                                    </div>
                                </SpeechBubble>
                            </div>
                        }
                    </a>
                </Link>
                <div className={styles.verticalBorder}/>
                <Link href={pointsRoute}>
                    <a className={styles.rewardWrapper} onClick={onPointClick}>
                        <span className={styles.rewardKey}>{t('MyInfoMobileCard.rewards.points')}</span>
                        <span className={styles.rewardValue}>{numberWithComma(user.point)}</span>
                    </a>
                </Link>
                <div className={styles.verticalBorder}/>
                <Link href={couponsRoute}>
                    <a className={styles.rewardWrapper} onClick={onCouponClick}>
                        <span className={styles.rewardKey}>{t('MyInfoMobileCard.rewards.coupons')}</span>
                        <span className={styles.rewardValue}>{user.coupon_count}</span>
                    </a>
                </Link>
            </div>
        </div>
    )
}


export function MyInfoCard() {
    return (
        <>
            <MyInfoMobileCardV2/>
        </>
    )
}
